import { useSelector } from "react-redux";
import Header from "../components/Header";
import { resolveImageUrl } from "../utils/branding";

const TopHeader = ({ onLogout }) => {
    const { userDetail } = useSelector((state) => state.login);

    const user = userDetail?.data || userDetail;
    const branding = user?.branding;

    const tenantBrandImage = resolveImageUrl(
        branding?.tenantBranding?.brandImage
    );

    const partnerBrandImage = resolveImageUrl(
        branding?.partnerBranding?.brandImage
    );

    return (
        <div className="top-header">
            <div
                className="logo"
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                }}
            >
                {/* Tenant logo: fallback to default logo */}
                <img
                    key={tenantBrandImage || "/logo.png"}
                    src={tenantBrandImage || "/logo.png"}
                    alt="Tenant Logo"
                    onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = "/logo.png";
                    }}
                    style={{
                        maxHeight: "45px",
                        maxWidth: "150px",
                        objectFit: "contain",
                    }}
                />

                {/* Partner logo: blank when unavailable */}
                {partnerBrandImage && (
                    <img
                        key={partnerBrandImage}
                        src={partnerBrandImage}
                        alt="Partner Logo"
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.style.display = "none";
                        }}
                        style={{
                            maxHeight: "45px",
                            maxWidth: "150px",
                            objectFit: "contain",
                        }}
                    />
                )}
            </div>

            <div className="user_info">
                <div className="top-menu">
                    <Header onLogout={onLogout} />
                </div>
            </div>
        </div>
    );
};

export default TopHeader;